import { useDispatch, useSelector } from "react-redux";

import Avatar from "@mui/material/Avatar";
import DeleteIcon from "@mui/icons-material/Delete";
import GridOnIcon from "@mui/icons-material/GridOn";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Tooltip from "@mui/material/Tooltip";

import { actionSheetFileRemoved, selectorSheet } from ".";
import { defaultSheetFile } from "./spreadsheetutils";

export default function UploadListItem({ sheetId }) {
  const dispatch = useDispatch();
  const { id, fileName, fillColor, lineColor, textColor } = useSelector(
    selectorSheet(sheetId),
  );
  const {
    fillColor: defaultFill,
    lineColor: defaultLine,
    textColor: defaultText,
  } = defaultSheetFile(sheetId);

  const style = {
    backgroundColor: fillColor || defaultFill,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: lineColor || defaultLine,
    color: textColor || defaultText,
  };

  const toggleRemoval = (id) => {
    dispatch(actionSheetFileRemoved({ id }));
  };

  return (
    <>
      <ListItem key={id}>
        <ListItemAvatar>
          <Avatar style={style}>
            <GridOnIcon />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={fileName} />
        <Tooltip title="Remove File">
          <IconButton
            arial-label="remove file"
            onClick={() => toggleRemoval(id)}
            size="large"
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </ListItem>
    </>
  );
}
